import { CfgUIElementState } from '@/stores/CfgUIElementState';
import { ICompositeProductApi } from '@canvas-logic/clp-sdk';

import {
  AttributeKey,
  ComponentKey,
  hasAttributeValue,
  IAttributeTextData,
  IAttributeValueTextData,
} from '@canvas-logic/clp-domain';
import { IUICfgAttribute } from '@canvas-logic/clp-api-types';
import { attributeLookupBehaviour } from '@/ui-kit/domain/lookup/behaviours';
import { AttributeLookup } from '@/ui-kit/domain/lookup/AttributeLookup';
import { action, computed, makeObservable, observable } from 'mobx';

let id = 0;

export abstract class AttributeCfgUIElementStateBase<T extends IUICfgAttribute> extends CfgUIElementState {
  public id = 'attribute-view-state-' + ++id;
  public readonly lookup: AttributeLookup;
  public visible = true;
  protected dependentAttributes: any[] = [];
  public viewElement: T;
  public textData: IAttributeTextData;
  readonly componentKey: ComponentKey;
  readonly attributeKey: AttributeKey;

  get selectedTextData(): IAttributeValueTextData | undefined {
    const data = this.textData.values.find(
      (value) =>
        this.lookup.current &&
        hasAttributeValue(this.lookup.current?.value) &&
        this.lookup.current?.value?.value === value.value,
    );
    return data;
  }

  constructor(public readonly api: ICompositeProductApi, public readonly element: T) {
    super();

    this.viewElement = element;

    const source = this.viewElement.source;
    this.componentKey = source.componentKey;
    this.attributeKey = source.attributeKey;
    this.visible = this.api.isAvailable(this.componentKey);

    const lookup = new AttributeLookup(this.api, this.componentKey, this.attributeKey);
    this.lookup = lookup;

    // TODO:
    // this.dependentAttributes = this.api.getDependentAttributesForAttribute(this.componentKey, source.attributeKey);
    attributeLookupBehaviour(lookup, this);
    this.textData = this.api.getComponentAttributeData(this.componentKey, this.attributeKey);

    makeObservable(this, {
      visible: observable,
      selectedTextData: computed,
      setVisibility: action.bound,
      textData: observable,
      lookup: observable,
    });
  }

  setVisibility(visibility: boolean) {
    this.visible = visibility;
  }

  update() {
    this.updaveVisibility();
  }

  updaveVisibility() {
    this.visible = this.api.isAvailable(this.componentKey);
  }
}
